import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { MultipleQueryTypesense } from "../../../../Typesense";
import { getLocalStorageItem } from "../../../../controllers/localStorage/getLocalStorage";
import { Autocomplete, TextField } from "@mui/material";
import okIcon from "../../../../assets/icons/new-icons/ok.svg";
import exitIcon from "../../../../assets/icons/new-icons/exit.svg";
import PropertyIcon from "../../assets/Icons/propertyAvatar1.svg";

import "./PropertiesModal.css";
import GetOpenDealsForProperty from "../../../../controllers/Enquiries/GetOpenDealsForProperty";
import PropertiesContent from "../../../Properties/PropertiesContent/PropertiesContent";
import GetAllProperties from "../../../../controllers/properties/GetAllProperties";

const style = {
  position: "absolute",
  top: "37%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px",

  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  minHeight: "60vh",
};

const PropertiesModal = (props) => {
  const { modalStatus, setModalStatus, property, setProperty, interest } =
    props;

  const [toggleAutoComplete, setToggleAutoComplete] = useState(true);
  const [inputSearch, setInputSearch] = useState("");
  const [localProperties, setLocalProperties] = useState([]);
  const [isClicked, setIsClicked] = useState(false);

  const handleSubmit = () => {
    setIsClicked(true);
    if (property) {
      handleClose();
    }
  };
  const [pWarning, setpWarning] = useState("");
  useEffect(() => {
    async function fetchAndCheck() {
      let deals = await GetOpenDealsForProperty(property.id);
      if (deals.length !== 0) {
        setpWarning("Note: This property is also open in another deal");
      } else {
        setpWarning("");
      }
    }
    fetchAndCheck();
  }, [property]);
  // useEffect(() => {
  //   async function fetchPropertiesTypsenseWithSearch() {
  //     let properties = (
  //       await MultipleQueryTypesense({
  //         searches: [
  //           {
  //             collection: "properties",
  //             q: inputSearch,
  //             page: 1,
  //             per_page: 10,
  //             query_by: "propertyTitle",
  //             filter_by: `is_deleted:=false && status:=shared && sharedParties:=[${getLocalStorageItem(
  //               "bid"
  //             )}]  ${
  //               interest === "buy"
  //                 ? ""
  //                 : interest === "sale"
  //                 ? "&& sellingPrice :> 0"
  //                 : "&& rentalPrice :> 0"
  //             } && propertyStatus:=available`,
  //           },
  //           {
  //             filter_by: `is_deleted:=false && bid:=${getLocalStorageItem(
  //               "bid"
  //             )}   ${
  //               interest === "buy"
  //                 ? ""
  //                 : interest === "sale"
  //                 ? "&& sellingPrice :> 0"
  //                 : "&& rentalPrice :> 0"
  //             }&& propertyStatus:=available`,
  //             collection: "properties",
  //             page: 1,
  //             per_page: 10,
  //             query_by: "propertyTitle",
  //             q: inputSearch,
  //           },
  //         ],
  //       })
  //     ).map(({ document }) => document);
  //     setLocalProperties([...properties]);
  //   }

  //   fetchPropertiesTypsenseWithSearch();
  // }, [inputSearch, interest]);

  useEffect(() => {
    async function fetchData() {
      if (inputSearch.length > 0) {
        const array = [];
        for (let i = 0; i < localProperties.length; i++) {
          if (
            localProperties[i].name
              .toLowerCase()
              .includes(inputSearch.toLowerCase())
          ) {
            array.push(localProperties[i]);
          }
        }
        setLocalProperties(array);
      } else {
        const prop = await GetAllProperties();

        setLocalProperties(prop);
      }
    }
    fetchData();
  }, [inputSearch]);
  const handleClose = () => {
    setIsClicked(false);
    setModalStatus(false);
  };
  return (
    <Modal
      open={modalStatus}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} className="Custom-Modal-Box">
        <div className="client-modal-title">
          <p className="modal-heading">Property</p>
          <div
            className="modal-close-icon"
            onClick={() => {
              setModalStatus(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              fill="currentColor"
              class="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </div>
        </div>
        <hr className="mb-4" />

        <div className="properties-card-body">
          <div>
            <Autocomplete
              disablePortal
              open={toggleAutoComplete}
              onOpen={() => setToggleAutoComplete(true)}
              onClose={() => setToggleAutoComplete(false)}
              id="combo-box-demo"
              options={localProperties}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={(event, value, reason, details) => {
                setProperty(value);
                if (!property) {
                  handleClose();
                }
              }}
              getOptionLabel={(option) => option.propertyTitle ?? ""}
              // sx={{ width: 300 }}
              defaultValue={!property ? null : property}
              onInputChange={(e, newInputValue) => {
                setInputSearch(newInputValue);
              }}
              inputValue={inputSearch ?? ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select a property"
                  hiddenLabel
                  value={inputSearch ?? ""}
                  // id="outlined-basic"
                  // variant="outlined"
                />

                // <input {...params} label="Movie" />
              )}
              renderOption={(props, option) => {
                // return <div {...props}>{option.propertyTitle}</div>;
                return (
                  <div {...props} key={option.id}>
                    <PropertiesContent
                      property={option}
                      isAddDeal={true}
                      {...props}
                    />
                  </div>
                  // <>
                  //   <Box className="select-property-element" {...props}>
                  //     <div className="element-left">
                  //       {option?.images.length ? (
                  //         <img
                  //           src={option.images[0]}
                  //           className="property-select-img"
                  //           width={40}
                  //           height={40}
                  //           style={{
                  //             borderRadius: "7px",
                  //           }}
                  //         />
                  //       ) : (
                  //         <img
                  //           src={
                  //             "http://localhost:4000/static/media/loadingImg.bb9a6f7e052abd552a1f.gif"
                  //           }
                  //           width="40"
                  //           height="45"
                  //           className="icon"
                  //         />
                  //       )}
                  //     </div>
                  //     <div className="add-deal-property-element-right">
                  //       <p className="add-deal-property-title">
                  //         {option.propertyTitle}
                  //       </p>
                  //       <p className="add-deal-property-address">
                  //         {option.address}
                  //       </p>
                  //       <p className="add-deal-property-price">
                  //         {option?.availableForRent
                  //           ? option?.rentalPrice
                  //           : option?.sellingPrice}
                  //       </p>
                  //     </div>
                  //   </Box>
                  //   <div className="line"></div>
                  // </>
                );
              }}
            />
            {isClicked && !property ? (
              <small className="errorMessage">Please select a Property</small>
            ) : (
              <small className="infoMessage">{pWarning}</small>
            )}
          </div>
          <Box className="add-deal-btn-container">
            <button
              className="close-modal-btn"
              onClick={() => {
                setModalStatus(false);
              }}
            >
              Cancel
            </button>
            <button className="form-submit-button" onClick={handleSubmit}>
              Save
            </button>
          </Box>
        </div>
      </Box>
    </Modal>
  );
};

export default PropertiesModal;
